import { Component, OnInit } from '@angular/core';
import { DragAndDropBaseComponent } from '../drag-and-drop-base-component/drag-and-drop-base.component';
import { BrandService } from './../../../../shared/services/brand/brand.service';
import { TranslatorService } from './../../../../shared/services/utils/translator.service';

@Component({
  selector: 'ngx-brand-drag-and-drop',
  templateUrl: './../drag-and-drop-base-component/drag-and-drop-base.component.html',
  styleUrls: ['./../drag-and-drop-base-component/drag-and-drop-base.component.scss']
})
export class BrandDragAndDropComponent extends DragAndDropBaseComponent implements OnInit {

  constructor(private readonly brandService: BrandService, translatorService: TranslatorService) {
    super(translatorService);
  }

  ngOnInit() {
    this.brandService.brandsQuery$(null, null).subscribe(res => {
      this.itemsList = this.itemsList.concat(res.brandList);
    });

  }

}
